import BaseFeature from '../../foundation/base/base';

class CardNavigation extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.cardNavigation = this.el;
		this.body = window.features.dom.body;
		this.addClick();
	}

	addClick() {
		function syncHeightCard() {
			// Don't sync heights if screen width is less than 640px
			const isSmallScreen = window.features.dom.body.offsetWidth < 640;

			const nodeBodyList = document.getElementsByClassName('o-card-navigation__body');
			const elemsAssingBody = [].slice.call(nodeBodyList);

			const tallestBody = Math.max(...elemsAssingBody.map((elemBody) => {
				elemBody.style.minHeight = '0'; // eslint-disable-line no-param-reassign
				return elemBody.offsetHeight;
			}));

			elemsAssingBody.forEach((elemBody) => {
				if (isSmallScreen) {
					elemBody.style.minHeight = 'auto'; // eslint-disable-line no-param-reassign
				} else {
					elemBody.style.minHeight = tallestBody + 'px'; // eslint-disable-line no-param-reassign
				}
			});

			// Sync height Card Content
			const nodeContentList = document.getElementsByClassName('o-card-navigation__center-content');
			const elemsContent = [].slice.call(nodeContentList);

			const tallestContent = Math.max(...elemsContent.map((elemContent) => {
				elemContent.style.minHeight = ''; // eslint-disable-line no-param-reassign
				return elemContent.offsetHeight;
			}));

			elemsContent.forEach((elemContent) => {
				if (isSmallScreen) {
					elemContent.style.minHeight = 'auto'; // eslint-disable-line no-param-reassign
				} else {
					elemContent.style.minHeight = tallestContent + 'px';// eslint-disable-line no-param-reassign
				}
			});

			// Sync height Card Heading
			const nodeHeaderList = document.getElementsByClassName('a-heading o-card-navigation__header');
			const elemsHeading = [].slice.call(nodeHeaderList);

			const tallestHeading = Math.max(...elemsHeading.map((elemHeading) => {
				elemHeading.style.minHeight = ''; // eslint-disable-line no-param-reassign
				return elemHeading.offsetHeight;
			}));

			elemsHeading.forEach((elemHeading) => {
				if (isSmallScreen) {
					elemHeading.style.minHeight = 'auto'; // eslint-disable-line no-param-reassign
				} else {
					elemHeading.style.minHeight = tallestHeading + 'px'; // eslint-disable-line no-param-reassign
				}
			});

			// Sync height Card sub headings
			const nodeSubHeaderList = document.getElementsByClassName('o-card-navigation__subheader');
			const elemsSubHeading = [].slice.call(nodeSubHeaderList);

			const tallestSubHeading = Math.max(...elemsSubHeading.map((elemSubHeading) => {
				elemSubHeading.style.minHeight = ''; // eslint-disable-line no-param-reassign
				return elemSubHeading.offsetHeight;
			}));

			elemsSubHeading.forEach((elemSubHeading) => {
				if (isSmallScreen) {
					elemSubHeading.style.minHeight = 'auto'; // eslint-disable-line no-param-reassign
				} else {
					elemSubHeading.style.minHeight = tallestSubHeading + 'px'; // eslint-disable-line no-param-reassign
				}
			});
		}
		if (this.el) {
			// Wait for all the images to load calculate
			setTimeout(() => {
				syncHeightCard();
			}, 1000);
			syncHeightCard();
			window.addEventListener('resize', syncHeightCard);
		}
	}
}

export default CardNavigation;
